import Head from "next/head";
import LegendsPage from "../../src/info/LegendsPage.tsx";

export default function LegendsInfo({ legends }) {
  return (
    <>
      <Head>
        <title>TFT Set 9.5 Legends Info</title>
      </Head>
      <LegendsPage legends={legends} />
    </>
  );
}

//
export async function getStaticProps({ locale }) {
  const legendsResp = await fetch(
    `https://ap.tft.tools/static/s95/legends_${locale}.json`,
  );
  const legends = await legendsResp.json();

  return {
    props: {
      legends,
    },
    revalidate: 3600,
  };
}
